$(document).ready(function() {
  var windowSize = $(window).width();
  if (windowSize < 767) {
  $(".custom-link-list > h2").on("click", function() {
    if ($(this).hasClass("active")) {
      $(this).removeClass("active");
      $(this).siblings(".footer-block__details-list").removeClass('active');
      } else {
      $(".custom-link-list > h2").removeClass("active");
      $(this).addClass("active");
      $(".footer-block__details-list").removeClass('active');
      $(this).siblings(".footer-block__details-list").addClass('active');
    }
  });
   }

  $(window).on('scroll', function() {
  if ($('.shopify-section-header-sticky').hasClass('scrolled-past-header')) {
    $('.announcement-bar-section').addClass('scrolled-past-header');
  } else {
    $('.announcement-bar-section').removeClass('scrolled-past-header');
  }
  // var sectionOffset = $('.product-form__submit').offset().top + $('.product-form__submit').outerHeight() - 120;  
  // if ($(window).scrollTop() > sectionOffset) {
  //     $('.product-footer-section').addClass('product-footer-section-fixed'); // Add the 'fixed' class
  // } else {
  //     $('.product-footer-section').removeClass('product-footer-section-fixed'); // Remove the 'fixed' class
  // }
  // Calculate the offsets and dimensions
  var sectionOffset = $('.product-form__submit').offset().top + $('.product-form__submit').outerHeight() - 120;
  var footerTopOffset = $('footer').offset().top;
  var windowScrollTop = $(window).scrollTop();
  var windowHeight = $(window).height();
  
  // Determine if the footer section should be fixed or hidden
  if (windowScrollTop > sectionOffset && (windowScrollTop + windowHeight) < footerTopOffset) {
    $('.product-footer-section').addClass('product-footer-section-fixed').removeClass('product-footer-section-hidden'); // Fix the footer section
  } else if ((windowScrollTop + windowHeight) >= footerTopOffset) {
    $('.product-footer-section').removeClass('product-footer-section-fixed').addClass('product-footer-section-hidden'); // Hide the footer section
  } else {
    $('.product-footer-section').removeClass('product-footer-section-fixed product-footer-section-hidden'); // Remove both classes
  }  
});

    $('#sticky-product-add-to-cart').click(function(){
    $('.product-form__submit').trigger('click');
  });

  // Add the 'change' event listener
$('.product-form__input--swatch input').on('click', function() {
    // Get the text of the span element inside the form label
    var colorvalue = $('.product-form__input--swatch .form__label span').text();
    // Log the color value to the console
    console.log('colorvalue',colorvalue);
});

    // Add the 'change' event listener
$('.product-form-size input').on('click', function() {
    // Get the text of the span element inside the form label
    var Sizevalue = $('.product-form-size .form__label span').text();
    // Log the color value to the console
    console.log(Sizevalue);
});

  $('.custom-live-chat-button').click(function(){
    console.log('hello',$('inbox-online-store-chat').contents().find('.chat-toggle--bottom-right'));
    $('inbox-online-store-chat').contents().find('.chat-toggle--bottom-right').trigger('click');
  })
  
});
